import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';

const UserPage = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get(`/user/${userId}`); // → /api/user/123
        setUser(res.data);
      } catch (err) {
        console.error('Ошибка загрузки пользователя:', err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  if (loading) return <div>Загрузка профиля...</div>;
  if (!user) return <div>Пользователь не найден</div>;

  return (
    <div className="main-content">
      <h2>Профиль пользователя #{user.id}</h2>
      <p><strong>Логин:</strong> {user.username}</p>
      <p><strong>Имя:</strong> {user.name || '—'}</p>
      <p><strong>Фамилия:</strong> {user.surname || '—'}</p>
      <p><strong>Администратор:</strong> {user.admin ? 'Да' : 'Нет'}</p>
      <p><strong>Суперпользователь:</strong> {user.superuser ? 'Да' : 'Нет'}</p>
    </div>
  );
};

export default UserPage;